var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarsLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 52,
    viewBox: "0 0 138 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0L31.8374 17.9656H50.7275L35.4451 29.0689L41.2824 47.0344L26 35.9311L10.7176 47.0344L16.5549 29.0689L1.27253 17.9656H20.1626L26 0Z",
    fill: "#FFD166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 10L87.5922 21.0557H99.2169L89.8123 27.8885L93.4046 38.9443L84 32.1115L74.5954 38.9443L78.1877 27.8885L68.7831 21.0557H80.4078L84 10Z",
    fill: "#FFD166"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127 15L129.47 22.6008H137.462L130.996 27.2984L133.466 34.8992L127 30.2016L120.534 34.8992L123.004 27.2984L116.538 22.6008H124.53L127 15Z",
    fill: "#FFD166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsLeft);
export default __webpack_public_path__ + "static/media/stars_left.67ba5f66dac3e487cc4d199d9cfe0761.svg";
export { ForwardRef as ReactComponent };